
import componentInstanceId from '~/mixins/component-instance-id'
import WButton from '../w-button/w-button.vue'

export default {
  components: { WButton },
  mixins: [componentInstanceId('spin-button')],
  inject: {
    formControlIds: {
      default: () => ({}),
    },
  },
  inheritAttrs: false,
  props: {
    min: {
      type: Number,
      default: null,
    },
    max: {
      type: Number,
      default: null,
    },
    value: {
      type: Number,
      default: 0,
    },
    step: {
      type: Number,
      default: 1,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: WButton.props.size,
  },
  created() {
    this.timeout = 0
    this.pressed = 0
  },
  destroyed() {
    this.stopAutoStep()
  },
  methods: {
    stopAutoStep() {
      if (this.pressed !== 0) {
        this.pressed = 0
        clearTimeout(this.timeout)
        this.timeout = 0
        window.removeEventListener('mouseup', this.stopAutoStep)
      }
    },
    startAutoStep(direction) {
      this.stopAutoStep()

      this.pressed = direction

      const autoStepStartDelay = 500
      const autoStepMaxSpeedReachedAfter = 2
      const autoStepMinDelay = 80
      const autoStepMaxDelay = 200

      this.timeout = setTimeout(() => {
        const timeStarted = Date.now()

        const nextStep = () => {
          this.updateValue(this.value + this.step * this.pressed)

          const secondsExpired = Math.round((Date.now() - timeStarted) / 1000)
          const speed =
            1 - Math.min(secondsExpired / autoStepMaxSpeedReachedAfter, 1)

          const delay = autoStepMinDelay + speed * autoStepMaxDelay

          this.timeout = setTimeout(nextStep, delay)
        }

        nextStep()
      }, autoStepStartDelay)

      window.addEventListener('mouseup', this.stopAutoStep)
    },
    onPressIncrease() {
      this.startAutoStep(1)
    },
    onPressDecrease() {
      this.startAutoStep(-1)
    },
    getClampedValue(value) {
      return Math.min(
        Math.max(value, this.min ?? Number.NEGATIVE_INFINITY),
        this.max ?? Number.POSITIVE_INFINITY,
      )
    },
    onInput(e) {
      if (this.disabled) {
        return
      }
      this.updateValue(parseInt(e.target.value) || this.min)
    },
    onBlur() {
      if (this.$refs.input) {
        this.$refs.input.value = this.value
      }
    },
    updateValue(newValue) {
      const clampedValue = this.getClampedValue(newValue)
      if (clampedValue !== this.value) {
        this.$emit('input', clampedValue)
      }
    },
    onIncreaseClick() {
      if (this.disabled) {
        return
      }
      this.updateValue(this.value + this.step)
    },
    onDecreaseClick() {
      if (this.disabled) {
        return
      }
      this.updateValue(this.value - this.step)
    },
  },
}
